<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <v-col lg="12" class="ml-auto"></v-col>
    <b-tabs pills card vertical>
      <b-tab title="استعلام با نام شرکت" active>
        <b-card header-bg-variant="primary" header-text-variant="white">
          <template v-slot:header>
            <h6>پیگیری استعلام‌ها با نام مشتری</h6>
          </template>
          <v-row>
            <v-col cols="9">
              <v-text-field
                v-model="companySearchName"
                placeholder="لطفا نام مشتری یا بخشی از آن را وارد کنید"
                outlined
                dense
                @keyup.enter.native="searchCustomerByName()"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                color="primary"
                :disabled="isBusyCustomer || !companySearchName"
                @click="searchCustomerByName()"
                >جستجوی مشتری</v-btn
              >
            </v-col>
          </v-row>

          <b-table
            responsive
            show-empty
            :items="customerItems"
            :fields="customerFields"
            :current-page="customerCurrentPage"
            :per-page="perPage"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusyCustomer"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  class="btn btn-primary color mr-1 mb-1"
                  target="_blank"
                  :href="'/' + role + '/customerProfile/' + data.item.id"
                  >پرونده مشتری</a
                >
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="customerCurrentPage"
            :total-rows="customerTotalRows"
            :per-page="perPage"
            aria-controls="customers-tabel"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
          <br />
        </b-card>
      </b-tab>
      <b-tab title="استعلام با کد PK مشتری">
        <b-card header-bg-variant="primary" header-text-variant="white">
          <template v-slot:header>
            <h6>پیگیری استعلام‌ها با کد PK مشتری</h6>
          </template>
          <v-row class="p-0">
            <v-col cols="9">
              <v-text-field
                v-model="userInput"
                placeholder="لطفا کد PK مشتری یا بخشی از آن را وارد کنید"
                outlined
                dense
                @keyup.enter.native="searchCustomerByPk()"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="pb-0 text-left"
              ><v-btn
                color="primary"
                :disabled="isBusy || !userInput"
                @click="searchCustomerByPk()"
                >جستجو مشتری‌</v-btn
              ></v-col
            >
          </v-row>
          <b-table
            responsive
            show-empty
            :items="customers"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="customerCurrentPage2"
            :per-page="perPage"
            :busy="isBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  class="btn btn-primary color mr-1"
                  target="_blank"
                  :href="'/' + role + '/customerProfile/' + data.item.id"
                  >پرونده مشتری</a
                >
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="customerCurrentPage2"
            :total-rows="customerTotalRows2"
            :per-page="perPage"
            aria-controls="customers-tabel"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
          <br />
        </b-card>
      </b-tab>
      <b-tab title="استعلام با شماره سفارش مشتری">COMING SOON</b-tab>
      <b-tab title="سفارش با نام شرکت">COMING SOON</b-tab>
      <b-tab title="سفارش با کد PK">COMING SOON</b-tab>
      <b-tab title="سفارش با کد ردیابی مشتری">COMING SOON</b-tab>
      <b-tab title="رابط با نام شخص">
        <b-card header-bg-variant="primary" header-text-variant="white">
          <template v-slot:header>
            <h6>جستجوی رابط با نام شخص</h6>
          </template>
          <v-row>
            <v-col cols="9">
              <v-text-field
                v-model="peopleSearch"
                placeholder="لطفا نام رابط یا بخشی از آن را وارد کنید"
                outlined
                dense
                @keyup.enter.native="
                  !isBusyPeople && peopleSearch ? showPeople() : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                color="primary"
                :disabled="isBusyPeople || !peopleSearch"
                @click="showPeople()"
                >جستجوی رابط</v-btn
              >
            </v-col>
          </v-row>
          <b-table
            responsive
            show-empty
            selectable
            select-mode="single"
            :items="peopleItems"
            :fields="peopleFields"
            :per-page="perPage"
            :current-page="peopleCurrentPage"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusyPeople"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>

            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  class="btn color mr-1 mt-1"
                  :href="
                    '/' + role + '/customerProfile/' + data.item.customerId
                  "
                  target="_blank"
                  role="button"
                  >پرونده مشتری</a
                >
                <!-- <a
                    class="btn btn-primary mr-1 mt-1"
                    :href="
                      '/secretary/personEdit/' +
                      data.item.customerCode +
                      '/' +
                      data.item.id
                    "
                    target="_blank"
                    role="button"
                    >ویرایش</a
                  > -->
              </div>
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="peopleCurrentPage"
            :total-rows="peopleTotalRows"
            :per-page="perPage"
            aria-controls="customers-tabel"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
          <br />
        </b-card>
      </b-tab>

      <b-tab title="رابط با شماره موبایل">
        <b-card header-bg-variant="primary" header-text-variant="white">
          <template v-slot:header>
            <h6>جستجوی رابط با شماره موبایل</h6>
          </template>
          <v-row>
            <v-col cols="9">
              <v-text-field
                v-model="peopleSearchByMobile"
                placeholder="لطفا شماره موبایل رابط را وارد کنید"
                outlined
                dense
                @keyup.enter.native="
                  !isBusyPeopleByMobile && peopleSearchByMobile
                    ? showPeopleByMobile()
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                color="primary"
                :disabled="isBusyPeopleByMobile || !peopleSearchByMobile"
                @click="showPeopleByMobile()"
                >جستجوی رابط</v-btn
              >
            </v-col>
          </v-row>
          <b-table
            responsive
            show-empty
            selectable
            select-mode="single"
            :items="peopleItemsByMobile"
            :fields="peopleFields"
            :per-page="perPage"
            :current-page="peopleByMobileCurrentPage"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusyPeopleByMobile"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>

            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  class="btn color mr-1 mt-1"
                  :href="
                    '/' + role + '/customerProfile/' + data.item.customerId
                  "
                  target="_blank"
                  role="button"
                  >پرونده مشتری</a
                >
                <!-- <a
                    class="btn btn-primary mr-1 mt-1"
                    :href="
                      '/secretary/personEdit/' +
                      data.item.customerCode +
                      '/' +
                      data.item.id
                    "
                    target="_blank"
                    role="button"
                    >ویرایش</a
                  > -->
              </div>
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="peopleByMobileCurrentPage"
            :total-rows="peopleByMobileTotalRows"
            :per-page="perPage"
            aria-controls="customers-tabel"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
          <br />
        </b-card>
      </b-tab>

      <b-tab title="فیلتر تاریخ سفارش‌ها">
        <b-card header-bg-variant="primary" header-text-variant="white">
          <template v-slot:header>
            <h6>فیلتر تاریخ سفارش‌ها</h6>
          </template>
          <v-row>
            <v-col cols="5">
              <b-form-group label="از تاریخ">
                <date-picker
                  v-model="exchangeFrom"
                  :editable="true"
                ></date-picker>
              </b-form-group>
            </v-col>
            <v-col cols="5">
              <b-form-group label="تا تاریخ">
                <date-picker
                  v-model="exchangeTo"
                  :editable="true"
                ></date-picker>
              </b-form-group>
            </v-col>
            <v-col cols="2" class="align-middle">
              <b-btn @click="searchExchanges()" class="btn btn-dark mt-7">
                جستجو
              </b-btn>
            </v-col>
          </v-row>
          <b-table
            responsive
            show-empty
            id="detailsTable"
            :items="allExchanges"
            :fields="exchangesFields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="exchangeCurrentPage"
            :per-page="exchangePerPage"
            :busy="exchangeIsBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{
                  data.index + 1 + exchangePerPage * (exchangeCurrentPage - 1)
                }}
              </div>
            </template>

            <template v-slot:cell(code)="data">
              <div style="text-align: center; vertical-align: middle">
                <a :href="'/factory/order/' + data.item.id" target="_blank">
                  {{ data.value }}</a
                >
              </div>
            </template>
            <template v-slot:cell(customerName)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  :href="
                    '/' + role + '/customerProfile/' + data.item.customerId
                  "
                  target="_blank"
                >
                  {{ data.value }}</a
                >
              </div>
            </template>

            <template v-slot:cell(progress)="data">
              <v-progress-circular
                :rotate="270"
                :size="40"
                :width="3"
                :value="data.item.progress"
                color="teal"
              >
                {{ data.item.progress }}%
              </v-progress-circular>
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="exchangeCurrentPage"
            :total-rows="allExchanges.length"
            :per-page="exchangePerPage"
            aria-controls="detailsTable"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
          <br />
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data: function () {
    return {
      guide: false,
      customerOK: false,
      customerItems: [],
      customerFields: [
        { key: "customerCode", label: "کد مشتری" },
        { key: "name", label: "نام مشتری" },
        { key: "type", label: "نوع مشتری" },
        { key: "operation", label: "عملیات" },
      ],
      ExcelFields: [
        { field: "customerCode", label: "کد مشتری" },
        { field: "name", label: "نام مشتری" },
        { field: "type", label: "نوع مشتری" },
      ],
      isBusyCustomer: false,
      rejectReason: "",
      companySearchName: "",
      companySearchPK: "",
      customerOK2: false,
      totalRows2: "",
      fields: [
        { key: "customerCode", label: "کد مشتری" },
        { key: "name", label: "نام مشتری" },
        { key: "type", label: "نوع مشتری" },
        { key: "operation", label: "عملیات" },
      ],
      searchOpt: ["نام مشتری", "کد مشتری"],
      sortBy: "",
      customers: [],
      customerTotalRows: 1,
      perPage: 10,
      customerCurrentPage: 1,
      customerTotalRows2: 1,
      customerCurrentPage2: 1,
      selectedCustomer: {},
      userInput: "",
      currentPage2: 1,
      customerItems2: [],
      isBusyCustomer2: false,
      busy: false,
      isBusy: false,
      orderSearch: "",
      isBusyOrder3: false,
      orderOK3: false,
      orderItems3: [],
      peopleSearch: "",
      peopleOK: false,
      peopleItems: [],
      peopleSearchByMobile: "",
      peopleByMobileOK: false,
      peopleItemsByMobile: [],
      peopleFields: [
        { key: "name", label: "نام رابط" },
        { key: "customer", label: "نام شرکت" },
        { key: "role", label: "سمت" },
        { key: "mobile", label: "موبایل" },
        { key: "operation", label: "عملیات" },
      ],
      isBusyPeople: false,
      peopleCurrentPage: 1,
      peopleTotalRows: 1,
      isBusyPeopleByMobile: false,
      peopleByMobileCurrentPage: 1,
      peopleByMobileTotalRows: 1,
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: "",
      currentOrder: {},
      items: [],
      filter: null,
      fields1: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fields2: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fieldsen: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "index", label: "#" },
      ],
      fieldsCI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fields2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fieldsenCI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "index", label: "#" },
      ],
      uniqueValues: [],
      content: "",
      role: "",
      currentOrder: {},
      response: "none",
      responses: [
        {
          value: "none",
          text: "پاسخی دریافت نشده است",
          status: "در انتظار نظر مشتری",
        },
        {
          value: "yes",
          text: "با تعیین قیمت موافقم",
          status: "تایید تعیین قیمت توسط مشتری",
        },
        {
          value: "no",
          text: "با تعیین قیمت مخالفم",
          status: "رد تعیین قیمت توسط مشتری",
        },
        {
          value: "revision",
          text: "تعیین قیمت نیاز به بازبینی دارد",
          status: "بازبینی تعیین قیمت",
        },
      ],
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      exchangeFrom: "",
      exchangeTo: "",
      allExchanges: [],
      exchangeIsBusy: false,
      exchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: " کد ردیابی" },
        { key: "customerName", label: "نام مشتری" },
        { key: "factoryDate", label: "تاریخ ارسال به کارخانه" },
        { key: "factoryStatus", label: "وضعیت سفارش" },
        { key: "priority", label: "اولویت" },
        { key: "progress", label: "پیشرفت" },
        { key: "registerDate", label: "تاریخ ثبت" },
      ],
      exchangeCurrentPage: 1,
      exchangePerPage: 10,
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    searchCustomerByName() {
      this.isBusyCustomer = true;
      Axios.post(
        this.baseUrl + "/ppkpms/customers/getByName",
        {
          name: this.companySearchName,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusyCustomer = false;
          if (res.status == 200) {
            this.customerItems = res.data;
            this.customerTotalRows = this.customerItems.length;
            this.customerCurrentPage = 1;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.isBusyCustomer = false;
          this.toast(err.response.data, "error");
        });
    },
    searchCustomerByPk() {
      //searching in customers to get customerId for searching by customerId
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/customers/getByCode",
        {
          code: this.userInput,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.customers = res.data;
            this.customerTotalRows2 = this.customers.length;
            this.customerCurrentPage2 = 1;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.isBusy = false;
          this.toast(err.response.data, "error");
        });
    },
    searchExchanges() {
      this.exchangeIsBusy = true;
      let startDate = this.exchangeFrom + " 00:00";
      let endDate = this.exchangeTo + " 23:59";
      Axios.post(
        this.baseUrl + "/ppkpms/factory/orders/getByFactoryDate",
        {
          startDate: startDate,
          endDate: endDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allExchanges = res.data;
            this.exchangeIsBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },

    printPreview2(item, type) {
      // let customerIndex =
      //   item.totalOrder.custom_fields.filter((x) => x.id == 157)[0].value ==
      //   "true";
      // let hasSizeStandard =
      //   item.totalOrder.custom_fields.filter((x) => x.id == 164)[0].value ==
      //   "true";
      // let formTemplate = item.totalOrder.custom_fields.filter(
      //   (x) => x.id == 152
      // )[0].value;
      // let myFields =
      //   type == "مالی"
      //     ? (customerIndex
      //         ? formTemplate == "pk1"
      //           ? this.fieldsCI
      //           : formTemplate == "pk2"
      //           ? this.fields2CI
      //           : this.fieldsenCI
      //         : formTemplate == "pk1"
      //         ? this.fields1
      //         : formTemplate == "pk2"
      //         ? this.fields2
      //         : this.fieldsen
      //       ).filter((x) => x.key != "details")
      //     : (customerIndex
      //         ? formTemplate == "pk1"
      //           ? this.fieldsCI
      //           : formTemplate == "pk2"
      //           ? this.fields2CI
      //           : this.fieldsenCI
      //         : formTemplate == "pk1"
      //         ? this.fields1
      //         : formTemplate == "pk2"
      //         ? this.fields2
      //         : this.fieldsen
      //       )
      //         .filter((x) => x.key != "totalPrice")
      //         .filter((x) => x.key != "perPrice");
      // localStorage.previewItem = JSON.stringify(
      //   new Object({
      //     fields: hasSizeStandard
      //       ? myFields
      //       : myFields.filter((x) => x.key != "dimensionStandard"),
      //     customerTerms: item.totalOrder.custom_fields
      //       .filter((x) => x.id == 153)[0]
      //       .value.replace("فنی / مالی", type),
      //     items: JSON.parse(
      //       item.totalOrder.custom_fields.filter((x) => x.id == 156)[0].value
      //     ),
      //     terms: item.totalOrder.custom_fields.filter((x) => x.id == 154)[0]
      //       .value,
      //     order: item.totalOrder,
      //     type: type,
      //     vat: item.totalOrder.custom_fields.filter((x) => x.id == 165)[0]
      //       .value,
      //     packagingCost: item.totalOrder.custom_fields.filter(
      //       (x) => x.id == 166
      //     )[0].value,
      //     transportCost: item.totalOrder.custom_fields.filter(
      //       (x) => x.id == 167
      //     )[0].value,
      //     personCost: item.totalOrder.custom_fields.filter(
      //       (x) => x.id == 168
      //     )[0].value,
      //     coatingCost: item.totalOrder.custom_fields.filter(
      //       (x) => x.id == 169
      //     )[0].value,
      //     otherCost: item.totalOrder.custom_fields.filter((x) => x.id == 170)[0]
      //       .value,
      //     discount: item.totalOrder.custom_fields.filter((x) => x.id == 171)[0]
      //       .value,
      //   })
      // );
      // let routeData = this.$router.resolve({
      //   path: "/printPreview",
      // });
      // window.open(routeData.href, "_blank");
    },
    showPeopleByMobile() {
      this.isBusyPeopleByMobile = true;
      this.peopleByMobileOK = false;
      Axios.post(
        this.baseUrl + "/ppkpms/agents/searchByMobile",
        {
          mobile: this.peopleSearchByMobile,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusyPeopleByMobile = false;
          if (res.status == 200) {
            this.peopleItemsByMobile = res.data;
            this.peopleByMobileTotalRows = this.peopleItemsByMobile.length;
            this.peopleByMobileOK = true;
            this.peopleByMobileCurrentPage = 1;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.isBusyPeopleByMobile = false;
          this.toast(err.response.data, "error");
        });
    },
    showPeople() {
      this.isBusyPeople = true;
      this.peopleOK = false;
      Axios.post(
        this.baseUrl + "/ppkpms/agents/getByName",
        {
          name: this.peopleSearch,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusyPeople = false;
          if (res.status == 200) {
            this.peopleItems = res.data;
            this.peopleTotalRows = this.peopleItems.length;
            this.peopleOK = true;
            this.peopleCurrentPage = 1;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.isBusyPeople = false;
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.exchangeTo = moment(new Date()).format("jYYYY/jMM/jDD");
    this.exchangeFrom = moment(new Date())
      .subtract(7, "d")
      .format("jYYYY/jMM/jDD");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.nav-pills {
  padding: 10px !important;
}
</style>
